var _rect, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSecurity(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 56,
    viewBox: "0 0 57 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.666992,
    width: 56,
    height: 56,
    rx: 28,
    fill: "url(#paint0_linear_406_13834)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.4245 17.0299C28.5837 16.99 28.7503 16.99 28.9095 17.0299L36.9095 19.0299C37.3547 19.1411 37.667 19.5411 37.667 20V28C37.667 31.4464 35.3852 34.2003 33.3255 36.0026C32.2746 36.9221 31.2284 37.6408 30.447 38.1292C30.0552 38.3741 29.7273 38.5627 29.4951 38.6913C29.3789 38.7556 29.2864 38.805 29.2217 38.839C29.1893 38.856 29.1638 38.8692 29.1457 38.8784L29.1242 38.8894L29.1178 38.8926L29.1156 38.8937L29.1148 38.8941C29.1145 38.8943 29.1142 38.8944 28.667 38C28.2198 38.8944 28.2195 38.8943 28.2192 38.8941L28.2184 38.8937L28.2162 38.8926L28.2097 38.8894L28.1882 38.8784C28.1702 38.8692 28.1447 38.856 28.1123 38.839C28.0476 38.805 27.9551 38.7556 27.8389 38.6913C27.6067 38.5627 27.2788 38.3741 26.887 38.1292C26.1055 37.6408 25.0594 36.9221 24.0085 36.0026C21.9487 34.2003 19.667 31.4464 19.667 28V20C19.667 19.5411 19.9793 19.1411 20.4245 19.0299L28.4245 17.0299ZM28.667 38L28.2198 38.8944C28.5013 39.0352 28.8327 39.0352 29.1142 38.8944L28.667 38ZM28.667 36.8628C28.8586 36.7541 29.1037 36.6103 29.387 36.4333C30.1055 35.9842 31.0594 35.3279 32.0085 34.4974C33.9487 32.7997 35.667 30.5536 35.667 28V20.7808L28.667 19.0308L21.667 20.7808V28C21.667 30.5536 23.3852 32.7997 25.3255 34.4974C26.2746 35.3279 27.2284 35.9842 27.947 36.4333C28.2303 36.6103 28.4754 36.7541 28.667 36.8628Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_406_13834",
    x1: 4.84355,
    y1: 1.48605e-7,
    x2: 56.4375,
    y2: 54.4613,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B42196"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52502,
    stopColor: "#6D85EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#08AABC"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecurity);
export default __webpack_public_path__ + "static/media/security.fc76f806fb53c2ed8b30982164e39e8c.svg";
export { ForwardRef as ReactComponent };